// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AdobeAcrobatIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <g clipPath="url(#adobeAcrobat_svga)">
      <path
        fill="#B30B00"
        d="M5.55 2.25h12.9a3.55 3.55 0 0 1 3.56 3.55v12.4a3.55 3.55 0 0 1-3.56 3.56H5.55A3.56 3.56 0 0 1 2 18.2V5.8c0-2 1.55-3.55 3.55-3.55"
      />
      <path
        fill="#fff"
        d="M17.95 13.52c-.93-1-3.49-.56-4.1-.5-.88-.87-1.5-1.86-1.75-2.24.31-.94.56-2 .56-3 0-.93-.37-1.86-1.36-1.86a1 1 0 0 0-.88.5c-.44.75-.25 2.24.44 3.8-.38 1.12-1 2.8-1.74 4.1-1 .38-3.18 1.38-3.37 2.5-.06.31.06.69.31.88.25.25.57.3.88.3 1.3 0 2.61-1.8 3.55-3.42a20 20 0 0 1 3.12-.81 4.8 4.8 0 0 0 3.24 1.43c.88 0 1.19-.38 1.3-.7.17-.29.05-.73-.2-.98m-.87.63c-.06.25-.38.5-.94.37q-1.04-.28-1.8-.93a9 9 0 0 1 2.24-.07c.25.07.56.25.5.63m-6.05-7.48a.3.3 0 0 1 .31-.19c.32 0 .38.38.38.7a9 9 0 0 1-.44 2.23c-.5-1.36-.44-2.36-.25-2.74m-.06 7.04c.31-.56.69-1.62.81-2 .31.57.88 1.2 1.13 1.5a10 10 0 0 0-1.94.5m-2.12 1.44c-.87 1.37-1.68 2.24-2.18 2.24-.06 0-.19 0-.25-.06-.06-.13-.12-.25-.06-.38.06-.5 1.06-1.18 2.5-1.8"
      />
    </g>
    <defs>
      <clipPath id="adobeAcrobat_svga">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>,
  "AdobeAcrobat",
);
export default AdobeAcrobatIcon;
